import React from 'react';
import Immutable from 'immutable';

import {
	Icon,
	styled
} from 'ps-gui';
import { getPhrase } from '../data/phrases';
import { ReactComponent as IntergramLogo } from '../svg/intergram.svg';
import { withGlobalContext } from '../data/globalcontext';

const Wrapper = styled.div`
	margin-top: 120px;
`;

const Links = styled.div`
	padding: 60px;
	background: #F3FAFD;
	text-align: center;
`;

const LinkContent = styled.div`
	font-size: 14px;
	font-weight: 500;
	.message {
		margin-bottom: 16px;
		color: #575757;
	}
	.icons {
		margin-bottom: 16px;
	}
	.icon {
		margin-right: 8px;
		margin-left: 8px;
	}
`;

const Bottom = styled.div`
	padding: 16px 21px;
	line-height: 30px;
	background: #E3F0F5;
	font-weight: 500;
	font-size: 14px;
	color: #575757CC;
	.right {
		float: right;
	}
	a {
		text-decoration: none;
		color: #306DA0;
		&:hover {
			text-decoration: underline;
		}
	}
`;

class PageFooter extends React.PureComponent {
	render() {
		return (
			<Wrapper>
				<Links>
					<LinkContent>
						<div className="message">{getPhrase('footer.socialNetworks')}</div>
						<div className="icons">
							{
								links.map(link => {
									const name = link.get('name');
									return (
										<a key={name} href={link.get('url')} target="_blank" rel="noreferrer">
											<Icon
												name={name}
											/>
										</a>
									);
								})
							}
						</div>
						<a href="https://www.intergram.cz/" target="_blank" rel="noreferrer">
							{
								!window.logoHi ? <IntergramLogo /> : <img alt="logo" src="/logo_hi.png" width="120px"/>
							}
						</a>
					</LinkContent>
				</Links>
				<Bottom>
					<span className="left">
						Powered by <a href="https://www.harmoneysw.com/" target="_blank" rel="noreferrer">HARMONEYsw.com</a>
					</span>
					<span className="right">
						<a href="http://www.intergram.cz/ochrana_osobnich_udaju/" target="_blank">{getPhrase('termsOfService')}</a>
					</span>
				</Bottom>
			</Wrapper>
		);
	}
}

const links = Immutable.fromJS([
	{ name: 'facebook', url: 'https://www.facebook.com/intergramCZ/' },
	{ name: 'instagram', url: 'https://www.instagram.com/intergramcz/' },
	// { name: 'x', url: 'https://x.com/intergramcz' },
	{ name: 'linkedIn', url: 'https://cz.linkedin.com/company/intergram' },
]);

export default withGlobalContext(PageFooter);
